module.exports = __webpack_public_path__ + "img/smb-key-keeper-pink.256.ba742bbc.png";